import React, { useEffect, useState } from "react";
import { Dropdown, FormGroup } from "semantic-ui-react";
import { getClientsBySearchQuery } from "../services/clients.service";
import { toast } from "react-toastify";
import Client from "../types/entities/Client";
import DropdownOption from "../types/models/DropdownOption";

interface SearchClientDropdownProps {
    optionSelected?: Client;
    value: string;
    setValue: (value: string) => void;
}

const SearchClientDropdown = ({ optionSelected, value, setValue }: SearchClientDropdownProps) => {

    const [searchQuery, setSearchQuery] = useState("");
    const [options, setOptions] = useState<DropdownOption[]>([]);
    const [isFetching, setIsFetching] = useState(false);

    const handleChange = (e: any, { value }: any) => {
        setValue(value);
    };

    const handleSearchChange = (e: any, { searchQuery }: any) => {
        setSearchQuery(searchQuery);
    };

    useEffect(() => {
        // Don't make the API call if the search query is less than 2 characters
        if (searchQuery.length < 2) {
            setOptions([]);
            return;
        }

        const delayDebounceFn = setTimeout(async () => {
            await fetchClients(searchQuery);
        }, 800);

        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery]);

    useEffect(() => {
        if (optionSelected) {
            setValue(optionSelected.id);
            setOptions([
                {
                    key: optionSelected.id,
                    text: `${optionSelected.person.fullName} - (${optionSelected.person.phone})`,
                    value: optionSelected.id
                }
            ]);
        }
    }, [optionSelected, setValue]);

    const fetchClients = async (query: string) => {
        setIsFetching(true);
        try {
            if (query === "") {
                setOptions([]);
                return;
            }

            const response = await getClientsBySearchQuery(100, 0, "createdAt,desc", query);

            const mappedOptions = response?.data.content.map((client: Client) => ({
                key: client.id,
                text: `${client.person.fullName} - (${client.person.phone})`,
                value: client.id
            }))

            setOptions(mappedOptions);
        } catch (error) {
            toast.error("Error al obtener el listado de clientes");
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <FormGroup grouped>
            <label style={{ display: "block" }}>Selecciona al cliente de la siguiente lista</label>
            <Dropdown
                labeled
                fluid
                selection
                search
                options={options}
                value={value}
                placeholder='Escribe al menos 3 caracteres para empezar a buscar'
                onChange={handleChange}
                onSearchChange={handleSearchChange}
                disabled={isFetching}
                loading={isFetching}
            />
        </FormGroup>
    );
}

export default SearchClientDropdown;